import CriteoOneTag from './third-party/CriteoOneTag';
import NewRelic from './third-party/NewRelic';
import OneTrust from './third-party/OneTrust';
import GoogleTagManager from './third-party/GoogleTagManager';
import FacebookPixel from './third-party/FacebookPixel';
import Optimize, { OptimizeAntiFlicker } from './third-party/Optimize';
import PixelCampaign from './third-party/PixelCampaign';
import Runnea, { RunneaConversion } from './third-party/Runnea';
import Sfmc from './third-party/Sfmc';
import TrackingLibrary from './third-party/TrackingLibrary';
import Citrus from './third-party/Citrus';
import Layout from './templates/Layout';
import UserTemplate from './templates/UserTemplate';
import Messages from './templates/Messages';
import ContextMessage from './context/message';
import CartData from './context/cart';

import {
    ApiResponses,
    Pages,
    logger,
    isInApp,
    Translations,
    TranslationPages,
    Store,
    Country,
    StoreDeliveryThreshold,
    Lang,
    Extension,
    Utils,
    Validate,
    generateUuid,
} from './utils';

export {
    // third party
    CriteoOneTag,
    GoogleTagManager,
    FacebookPixel,
    PixelCampaign,
    NewRelic,
    OneTrust,
    Optimize,
    OptimizeAntiFlicker,
    Runnea,
    RunneaConversion,
    Sfmc,
    TrackingLibrary,
    Citrus,

    // utils
    ApiResponses,
    Pages,
    logger,
    isInApp,
    Translations,
    TranslationPages,
    Store,
    Country,
    StoreDeliveryThreshold,
    Lang,
    Extension,
    Utils,
    Validate,
    generateUuid,

    // templates
    Layout,
    UserTemplate,
    Messages,

    // contexts
    ContextMessage,
    CartData,
};

export {
    trackEeViewItem,
    trackEeViewItemList,
    trackEeAddToCart,
    trackEeBeginCheckout,
    trackEePurchase,
} from './events/datalayer/src';
